// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"sM-z","carouselContainer":"tM-z"};